import script from "./CheckinsAutomationsTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckinsAutomationsTemplate.vue?vue&type=script&setup=true&lang=js"

import "./CheckinsAutomationsTemplate.vue?vue&type=style&index=0&id=08dd8de0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08dd8de0"]])

export default __exports__